import React from 'react';
import { BookCallButton } from './BookCallButton';
export function FoundingFooter() {
  return <footer className="border-t border-[#D4AF37]/15 bg-[#070609] pb-20 md:pb-0" data-id="element-1374" data-mp="1bo8u01tjrs1z">
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-8 px-5 py-12 sm:px-8 lg:flex-row lg:items-start lg:justify-between" data-id="element-1375" data-mp="1pevrxrrhhdx0">
        <div data-id="element-1376" data-mp="1lelbfl62f53w">
          <p className="font-serif text-2xl text-[#FDFBF7]" data-id="element-1377" data-mp="1le24t0lv8356">Sikh Kingdoms</p>
          <p className="mt-4 max-w-md text-sm font-light leading-relaxed text-[#FDFBF7]/55" data-id="element-1378" data-mp="xozcmytlurwf">
            Bringing the people, places and values of the Sikh Kingdoms to life
            for the generations who come next.
          </p>
          <p className="mt-5 max-w-xl text-xs font-light leading-relaxed text-[#FDFBF7]/35" data-id="element-1379" data-mp="16pxkxtb2tlkt">
            Historical narratives and visuals are developed with consultant
            review and a commitment to cultural integrity.
          </p>
        </div>
        <BookCallButton size="sm" data-id="element-1380" data-mp="2d5hnijkax5q4">Book a Call</BookCallButton>
      </div>

      <div className="border-t border-[#D4AF37]/10" data-id="element-1381" data-mp="jtbswqu98j8e">
        <div className="mx-auto flex w-full max-w-7xl flex-col gap-3 px-5 py-6 text-xs font-light text-[#FDFBF7]/30 sm:flex-row sm:items-center sm:justify-between sm:px-8" data-id="element-1382" data-mp="jssaza4ltuud">
          <p data-id="element-1383" data-mp="stqhq06fgggn">© 2026 Sikh Kingdoms. All rights reserved.</p>
          <p data-id="element-1384" data-mp="ss728bsli9fx">Privacy respected. No obligation.</p>
        </div>
      </div>
    </footer>;
}